import { mixin } from "lodash";

export const registerLodashMixins = () => {
    mixin({
        append: (array, element) => [...array, element],
        appendFirst: (array, element) => [element, ...array],
    });
};
